
import * as storyblokRuntime$fob92lqERDeXFDjNqzdTMUKRFjCUVN4NE44DlHTwrh8 from '/codebuild/output/src1547660482/src/ark/node_modules/@nuxt/image/dist/runtime/providers/storyblok'
import * as awsAmplifyRuntime$eyeRj_45be5lZwol_RrVHrJ8YgtoayupxinyWiQ_RbVPU from '/codebuild/output/src1547660482/src/ark/node_modules/@nuxt/image/dist/runtime/providers/awsAmplify'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "awsAmplify",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['storyblok']: { provider: storyblokRuntime$fob92lqERDeXFDjNqzdTMUKRFjCUVN4NE44DlHTwrh8, defaults: {"baseURL":"https://a.storyblok.com"} },
  ['awsAmplify']: { provider: awsAmplifyRuntime$eyeRj_45be5lZwol_RrVHrJ8YgtoayupxinyWiQ_RbVPU, defaults: {} }
}
        